import { Button, Image, Input, message, Select, Upload, Form, Row, Col, Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { getAllPlansIn, getUsersIn } from '../../api/functions';
import InputField from '../../components/InputField/InputField';
import { businessCategories, entityType } from '../../config/variable';
import { updateDealership } from '../../api/dealerhip';
import { getAllSaleYourBusiness, updateSellYourBusiness } from '../../redux/actions/AllActions';
import { useDispatch } from 'react-redux';


const { Option } = Select;
const { TextArea } = Input;

const EditSellYourBusiness = ({
    editingRecord, handleEditCancel
}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        businessName: editingRecord?.businessName,
        gstNumber: editingRecord?.gstNumber,
        entityType: editingRecord?.entityType,
        businessCategory: editingRecord?.businessCategory,
        businessPhotoUrl: editingRecord?.businessPhotoUrl,
        logoPhotoUrl: editingRecord?.logoPhotoUrl,



        address: editingRecord?.businessAddress?.address,
        street: editingRecord?.businessAddress?.street,
        city: editingRecord?.businessAddress?.city,
        country: editingRecord?.businessAddress?.country,
        state: editingRecord?.businessAddress?.state,
        postalCode: editingRecord?.businessAddress?.postalCode,
        businessOverview: editingRecord?.businessOverview,
        businessDetails: editingRecord?.businessDetails,
        
        
        typeOfBusinessPremises: editingRecord?.typeOfBusinessPremises,
        areaSqFt: editingRecord?.areaSqFt,


        reasonToSell: editingRecord?.reasonToSell,
        quotedValue: editingRecord?.quotedValue,


        annualSales: editingRecord?.annualSales,
        grossIncome: editingRecord?.grossIncome,
        ebitda: editingRecord?.ebitda,
        rentals: editingRecord?.rentals,
        noOfEmployees: editingRecord?.noOfEmployees,
        payment_status : editingRecord?.payment_status,
        acceptanceOfTermsAndConditions: editingRecord?.acceptanceOfTermsAndConditions,
        agreementToPrivacyPolicy: editingRecord?.agreementToPrivacyPolicy,
    });
    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateError = () => {
          let errObj = {};
          if (!formData?.businessName) errObj.businessName = "Business Name is required";
          if (!formData?.gstNumber) errObj.gstNumber = "GST number is required.";
          if (!formData?.entityType) errObj.entityType = "Entity Type is required.";
          if (!formData?.businessCategory) errObj.businessCategory = "Business Category is required.";
          if (!formData?.address) errObj.address = "Address is required";
          if (!formData?.street) errObj.street = "Street is required";
          if (!formData?.city) errObj.city = "City is required";
          if (!formData?.country) errObj.country = "Country is required.";
          if (!formData?.state) errObj.state = "State is required.";
          if (!formData?.postalCode) errObj.postalCode = "Postal Code is required.";
  
  
          if (!formData?.businessOverview) errObj.businessOverview = "Business Overview is required";
          if (!formData?.businessDetails) errObj.businessDetails = "Business details is required";
          if (!formData?.typeOfBusinessPremises) errObj.typeOfBusinessPremises = "Business details is required";
          if (!formData?.areaSqFt) errObj.areaSqFt = "Business details is required";
          if (!formData?.reasonToSell) errObj.reasonToSell = "Business details is required";
  
  
  
          if (!formData?.logoPhotoUrl) errObj.businessPhotoUrl = "Business Photo Url is required";
          if (!formData?.businessPhotoUrl) errObj.logoPhotoUrl = "Logo Photo Url is required";
  
          
          if (!formData?.quotedValue) errObj.quotedValue = "Quoted value is required";
          if (!formData?.annualSales) errObj.annualSales = " Annual sales  is required";
          if (!formData?.grossIncome) errObj.grossIncome = "Gross Income is required";
          if (!formData?.ebitda) errObj.ebitda = " Ebitda is required";
  
          if (!formData?.rentals) errObj.rentals = " Rentals is required.";
          if (!formData?.noOfEmployees) errObj.noOfEmployees = "No. of employee  is required";
          
  
  
          if (!formData?.acceptanceOfTermsAndConditions) errObj.acceptanceOfTermsAndConditions = "Acceptance of terms and condition is required";
          if (!formData?.agreementToPrivacyPolicy) errObj.agreementToPrivacyPolicy = "Agreement to privacy policy is required";
          if (!formData?.payment_status) errObj.payment_status = "Payment Status is required";

          setErrors(errObj);
          return Object.keys(errObj).length === 0;
    };
    
        
        const fetch = () => {
            dispatch(getAllSaleYourBusiness());
    
        }
    

    const handleSubmit = async () => {
        try {

            if (!validateError()) {
                message.error('Please fill all the required fields.');
                return;
            }

            if (formData?.gstNumber && formData?.gstNumber.length !== 15) {
                setErrors({
                    gstNumber: "GST Number should be 15 digits long"
                });
                return;
            }

            setLoading(true);
            await updateSellYourBusiness({
                id: editingRecord?._id,
                ...formData
            })
            handleEditCancel();
            fetch();
            message.success('Sell your business  updated successfully!');
        } catch (e) {
            console.log(e);
            message.error(e.response?.data?.message || 'Updation failed.');
        } finally {
            setLoading(false);
        }
    };

    const handleBusinessPhotoUrlChange = (e) => {
        let file = e.fileList[0]?.originFileObj;
        if (file.size > 500 * 1000) {
            message.error("File must not be more than 500kb.");
            return;
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            message.error("Only .jpg and .png files are allowed.");
            return;
        }
        setFormData({
            ...formData,
            businessPhotoUrl: file
        });
    };

    const handleLogoPhotoUrl = (e) => {
        let file = e.fileList[0]?.originFileObj;
        if (file.size > 500 * 1000) {
            message.error("File must not be more than 500kb.");
            return;
        }
        if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
            message.error("Only .jpg and .png files are allowed.");
            return;
        }
        setFormData({
            ...formData,
            logoPhotoUrl: file
        });
    };

    useEffect(() => {
        console.log(formData.businessPhotoUrl instanceof File, 'the file')

    }, [formData])

    return (
        <Card style={{ margin: '20px' }}>
            <Form layout="vertical">
                <Row gutter={16}>
                    <Col span={12}>
                        <InputField
                            name="businessName"
                            type="text"
                            placeholder="Enter Business Name"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Business Name"
                            errors={errors}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Upload Business Photo" required>
                            <Upload
                                beforeUpload={() => false}
                                onChange={handleBusinessPhotoUrlChange}
                                maxCount={1}
                                showUploadList={false}
                                accept=".jpg,.png"
                            >
                                <Button icon={<UploadOutlined />}>Upload Business Photo</Button>
                            </Upload>


                            {
                                errors && errors.businessPhotoUrl &&
                                <div
                                    style={{
                                        color: "red"
                                    }}
                                >

                                    {
                                        errors?.businessPhotoUrl
                                    }</div>
                            }

                            {formData?.businessPhotoUrl && (
                                <Image
                                    alt="Business Photo"
                                    width={100}
                                    src={

                                        formData.businessPhotoUrl instanceof File
                                            ?
                                            URL.createObjectURL(formData.businessPhotoUrl) : formData?.businessPhotoUrl}
                                    style={{ marginTop: '10px' }}
                                />
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Upload Logo" required>
                            <Upload
                                beforeUpload={() => false}
                                onChange={handleLogoPhotoUrl}
                                maxCount={1}
                                showUploadList={false}
                                accept=".jpg,.png"
                            >
                                <Button icon={<UploadOutlined />}>Upload Logo Photo</Button>
                            </Upload>
                            {
                                errors && errors.logoPhotoUrl && <div
                                    style={{
                                        color: "red"
                                    }}
                                >
                                    {
                                        errors?.logoPhotoUrl
                                    }</div>
                            }
                            {

                                formData?.logoPhotoUrl && (
                                    <Image
                                        width={100}
                                        src={

                                            formData?.logoPhotoUrl instanceof File ?
                                                URL.createObjectURL(formData.logoPhotoUrl) : formData.logoPhotoUrl}
                                        style={{ marginTop: '10px' }}
                                    />
                                )}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Select Entity Type" required>
                            <Select
                                  value={formData?.entityType}
                                name="entityType"
                                onChange={(value) => setFormData(prev => ({ ...prev, entityType: value }))}
                                placeholder="Select Entity Type"
                            >
                                {entityType.map((item) => (
                                    <Option key={item} value={item}>{item}</Option>
                                ))}
                            </Select>
                            {errors.entityType && <div style={{ color: 'red' }}>{errors.entityType}</div>}
                        </Form.Item>
                    </Col>
                </Row>


                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Select Business Category" required>
                            <Select
                                value={formData?.businessCategory}
                                name="businessCategory"
                                onChange={(value) => setFormData(prev => ({ ...prev, businessCategory: value }))}
                                placeholder="Select Business Category"
                            >
                                {businessCategories.map((item) => (
                                    <Option key={item} value={item}>{item}</Option>
                                ))}
                            </Select>
                            {errors.businessCategory && <div style={{ color: 'red' }}>{errors.businessCategory}</div>}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <InputField
                            name="gstNumber"
                            type="text"
                            placeholder="Enter GST Number"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="GST Number"
                            errors={errors}
                        />
                    </Col>
                </Row>


                <Row gutter={16}>
                    <Col span={12}>
                        <InputField
                            name="address"
                            type="text"
                            placeholder="Enter Address"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Address"
                            errors={errors}
                        />
                    </Col>
                    <Col span={12}>
                        <InputField
                            name="street"
                            type="text"
                            placeholder="Enter Street"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Street"
                            errors={errors}
                        />
                    </Col>
                    <Col span={8}>
                        <InputField
                            name="state"
                            type="text"
                            placeholder="Enter State"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="State"
                            errors={errors}
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={8}>
                        <InputField
                            name="city"
                            type="text"
                            placeholder="Enter City"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="City"
                            errors={errors}
                        />
                    </Col>
                    <Col span={8}>
                        <InputField
                            name="country"
                            type="text"
                            placeholder="Enter Country"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Country"
                            errors={errors}
                        />
                    </Col>
                    <Col span={8}>
                        <InputField
                            name="postalCode"
                            type="text"
                            placeholder="Enter Postal Code"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Postal Code"
                            errors={errors}
                        />
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <InputField
                            name="areaSqFt"
                            type="number"
                            placeholder="Enter area sq ft"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="AreaSqFt"
                            errors={errors}
                        />
                    </Col>
                    <Col span={8}>
                        <InputField
                            name="typeOfBusinessPremises"
                            type="text"
                            placeholder="Enter typeOfBusinessPremises"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Type Of BusinessPremises"
                            errors={errors}
                        />
                    </Col>
                    <Col span={8}>
                        <InputField
                            name="annualSales"
                            type="text"
                            placeholder="Enter annual sales"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Annual Sales"
                            errors={errors}
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item label="Business Overview" required>
                            <TextArea
                                name="businessOverview"
                                placeholder="Enter Business Overview"
                                value={formData.businessOverview}
                                onChange={handleInputChange}
                                rows={4}
                            />
                            {errors.businessOverview && <div style={{ color: 'red' }}>{errors.businessOverview}</div>}
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item label="Business Details" required>
                            <TextArea
                                name="businessDetails"
                                placeholder="Enter Business Details"
                                value={formData.businessDetails}
                                onChange={handleInputChange}
                                rows={4}
                            />
                            {errors.businessDetails && <div style={{ color: 'red' }}>{errors.businessDetails}</div>}
                        </Form.Item>
                    </Col>
                </Row>












                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item  label="Payment Status" required>
                            <Select
                                value ={formData?.payment_status}
                                name="payment_status"
                                onChange={(value) => setFormData(prev => ({ ...prev, payment_status: value }))}
                                placeholder="Select Payment Status"
                            >
                                <Option value="paid">Paid </Option>
                                <Option value="unpaid">Unpaid </Option>
                            </Select>
                            {errors.payment_status && <div style={{ color: 'red' }}>{errors.payment_status}</div>}
                        </Form.Item>
                    </Col>

                </Row>








                <Row gutter={16}>
                    <Col span={12}>
                        <InputField
                            name="reasonToSell"
                            type=""
                            placeholder="Enter Reason to sell"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Reason To Sell"
                            errors={errors}
                        />
                    </Col>

                </Row>

                <Row gutter={16}>

                    <Col span={12}>
                        <InputField
                            name="grossIncome"
                            type="number"
                            placeholder="Enter Gross Income"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Gross Income"
                            errors={errors}
                        />
                    </Col>
                    <Col span={12}>
                        <InputField
                            name="quotedValue"
                            type="number"
                            placeholder="Quoted Value"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Quoted Value"
                            errors={errors}
                        />
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <InputField
                            name="ebitda"
                            type="number"
                            placeholder="Enter Ebitda "
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Ebitda"
                            errors={errors}
                        />
                    </Col>
                    <Col span={12}>
                        <InputField
                            name="rentals"
                            type="text"
                            placeholder="Enter rentals"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="Rentals"
                            errors={errors}
                        />
                    </Col>
                </Row>


                <Row gutter={16}>
                    <Col span={12}>
                        <InputField
                            name="noOfEmployees"
                            type="number"
                            placeholder="Enter No. of employees"
                            formData={formData}
                            handleInputChange={handleInputChange}
                            label="No. of employees"
                            errors={errors}
                        />

                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Button type="primary" onClick={handleSubmit} style={{ width: '100%', marginTop: "20px" }}>
                            {
                                loading ? "Loading..." : "Submit"
                            }

                        </Button>
                    </Col>
                </Row>
            </Form>
        </Card>
    );
};

export default EditSellYourBusiness;